import ApiTransaction from "../../../../../../shared/model/ApiTransaction";
import React from "react";
import { getEncryptedPaymentToDisplay } from "shared/utils";
import { useStaticData } from "context/staticData";
import TransactionIdentifierDisplayType from "shared/enums/TransactionIdentifierDisplayType";

export default function PaymentDetails(props: { transaction?: ApiTransaction }) {
  const staticData = useStaticData();
  const transactionIdentifier = React.useMemo(() => {
    return getEncryptedPaymentToDisplay({
      staticData,
      transactionMethodType: props.transaction?.transactionMethodType,
      transactionIdentifier: props.transaction?.paymentMethodIdentifier,
      transactionIdentifierDisplayType: TransactionIdentifierDisplayType.HIDE
    });
  }, [props.transaction?.paymentMethodIdentifier, props.transaction?.transactionMethodType, staticData]);

  if (!transactionIdentifier) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="paymnentMethod--wrapper">
        <span className="paymnentMethod--cardNo">{transactionIdentifier}</span>
      </div>
    </React.Fragment>
  );
}
